/* Placeholder for Stages 4-14 — Session E wires the real module content in. */
export default function StageStub({ stageId }) {
  return (
    <div className="border border-dashed border-neutral-200 rounded-lg py-16 grid place-items-center bg-neutral-50"
         data-testid={`stage-stub-${stageId}`}>
      <div className="text-center max-w-md px-6">
        <div className="text-[10px] uppercase tracking-[0.18em] text-neutral-500 mb-2">Coming next</div>
        <h3 className="text-[15px] font-medium text-neutral-900">
          Stage {stageId} content wired in Session E
        </h3>
        <p className="text-[12px] text-neutral-500 mt-2 leading-relaxed">
          The pipeline shell + gating logic is in place. The existing module
          UI for this stage still runs under <span className="text-[#4CAF50]">Advanced Workspace</span>
          {" "}— toggle top-right to reach it while Session E surfaces each module inline here.
        </p>
      </div>
    </div>
  );
}
